<template>
  <div class="container mt-4">
    <div class="d-flex justify-content-between align-items-center mb-4">
      <h2>Users Management</h2>
      <button class="btn btn-primary" data-bs-toggle="offcanvas" data-bs-target="#userOffcanvas" @click="openCreateModal">
        <i class="fas fa-plus"></i> Add New User
      </button>
    </div>

    <!-- Users Table -->
    <div class="table-responsive">
      <table class="table table-bordered table-hover">
        <thead class="table-dark">
          <tr>
            <th>ID</th>
            <th>Name</th>
            <th>Email</th>
            <th>Role</th>
            <th>Status</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="user in users" :key="user.id">
            <td>{{ user.id }}</td>
            <td>{{ user.name }}</td>
            <td>{{ user.email }}</td>
            <td>{{ user.role }}</td>
            <td>
              <span :class="user.status === 'Active' ? 'badge bg-success' : 'badge bg-danger'">
                {{ user.status }}
              </span>
            </td>
            <td>
              <button class="btn btn-sm btn-info me-1" data-bs-toggle="offcanvas" data-bs-target="#userOffcanvas" @click="openEditModal(user)">
                <i class="fas fa-edit"></i>
              </button>
              <button class="btn btn-sm btn-danger" @click="deleteUser(user.id)">
                <i class="fas fa-trash"></i>
              </button>
            </td>
          </tr>
          <tr v-if="users.length === 0">
            <td colspan="6" class="text-center">No users found</td>
          </tr>
        </tbody>
      </table>
    </div>

    <!-- Bootstrap 5 Offcanvas Form -->
    <div class="offcanvas offcanvas-end" tabindex="-1" id="userOffcanvas">
      <div class="offcanvas-header">
        <h5 class="offcanvas-title">{{ isEdit ? 'Edit User' : 'Add New User' }}</h5>
        <button type="button" class="btn-close" data-bs-dismiss="offcanvas"></button>
      </div>
      <div class="offcanvas-body">
        <form @submit.prevent="saveUser">
          <div class="mb-3">
            <label class="form-label">Name</label>
            <input 
              type="text" 
              class="form-control" 
              v-model="formData.name" 
              required
            >
          </div>
          
          <div class="mb-3">
            <label class="form-label">Email</label>
            <input 
              type="email" 
              class="form-control" 
              v-model="formData.email" 
              required
            >
          </div>
          
          <div class="mb-3">
            <label class="form-label">Role</label>
            <select class="form-control" v-model="formData.role" required>
              <option value="">Select Role</option>
              <option value="Admin">Admin</option>
              <option value="User">User</option>
              <option value="Manager">Manager</option>
            </select>
          </div>
          
          <div class="mb-3">
            <label class="form-label">Status</label>
            <select class="form-control" v-model="formData.status" required>
              <option value="Active">Active</option>
              <option value="Inactive">Inactive</option>
            </select>
          </div>
          
          <div class="d-flex gap-2">
            <button type="submit" class="btn btn-primary flex-grow-1">
              <i class="fas fa-save"></i> Save
            </button>
            <button type="button" class="btn btn-secondary" data-bs-dismiss="offcanvas">
              Cancel
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Users',
  data() {
    return {
      users: [
        { id: 1, name: 'John Doe', email: 'john@example.com', role: 'Admin', status: 'Active' },
        { id: 2, name: 'Jane Smith', email: 'jane@example.com', role: 'User', status: 'Active' },
        { id: 3, name: 'Bob Wilson', email: 'bob@example.com', role: 'Manager', status: 'Inactive' }
      ],
      formData: {
        id: null,
        name: '',
        email: '',
        role: '',
        status: 'Active'
      },
      isEdit: false
    }
  },
  methods: {
    openCreateModal() {
      this.isEdit = false
      this.formData = {
        id: null,
        name: '',
        email: '',
        role: '',
        status: 'Active'
      }
    },
    
    openEditModal(user) {
      this.isEdit = true
      this.formData = { ...user }
    },
    
    saveUser() {
      if (this.isEdit) {
        // Update existing user
        const index = this.users.findIndex(u => u.id === this.formData.id)
        if (index !== -1) {
          this.users[index] = { ...this.formData }
          this.$toast('User updated successfully!', true)
        }
      } else {
        // Add new user
        const newUser = {
          id: this.users.length + 1,
          ...this.formData
        }
        this.users.push(newUser)
        this.$toast('User added successfully!', true)
      }
      
      // Close offcanvas using Bootstrap's data attribute
      const offcanvasElement = document.getElementById('userOffcanvas')
      const bsOffcanvas = bootstrap.Offcanvas.getInstance(offcanvasElement)
      if (bsOffcanvas) {
        bsOffcanvas.hide()
      } else {
        // If no instance, just trigger close button
        const closeBtn = offcanvasElement.querySelector('.btn-close')
        if (closeBtn) closeBtn.click()
      }
    },
    
    deleteUser(id) {
      if (confirm('Are you sure you want to delete this user?')) {
        this.users = this.users.filter(user => user.id !== id)
        this.$toast('User deleted successfully!', true)
      }
    }
  }
}
</script>

<style scoped>
.table th {
  cursor: pointer;
}

.btn-sm {
  margin: 0 2px;
}
</style>